"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ProvinceEnum;
(function (ProvinceEnum) {
    ProvinceEnum["AB"] = "AB";
    ProvinceEnum["BC"] = "BC";
    ProvinceEnum["MB"] = "MB";
    ProvinceEnum["ON"] = "ON";
    ProvinceEnum["SK"] = "SK";
    ProvinceEnum["NU"] = "NU";
    ProvinceEnum["NT"] = "NT";
})(ProvinceEnum = exports.ProvinceEnum || (exports.ProvinceEnum = {}));
var Timezone;
(function (Timezone) {
    Timezone["PACIFIC"] = "America/Vancouver";
    Timezone["MOUNTAIN"] = "America/Edmonton";
    Timezone["CENTRAL"] = "America/Regina";
    Timezone["EASTERN"] = "America/Toronto";
    Timezone["ATLANTIC"] = "America/Halifax";
})(Timezone = exports.Timezone || (exports.Timezone = {}));
var RefundProductsType;
(function (RefundProductsType) {
    RefundProductsType["ACCESSORIES"] = "accessories";
    RefundProductsType["CANNABIS"] = "cannabis";
    RefundProductsType["MIXED"] = "mixed";
})(RefundProductsType = exports.RefundProductsType || (exports.RefundProductsType = {}));
//# sourceMappingURL=Company.js.map